// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getStaffsListStatus: { data: null },
  createStaffsStatus: { data: null },
  updateStaffStatusStatus: { data: null },
  getStaffStatus: { data: null },
  resetPasswordStatus: { data: null },
  deleteStaffStatus: { data: null },
  getActivityListStatus: { data: null },
};
